import Wrapper from "@/components/layout/Wrapper";
import type { Breakpoint } from "@/lib/types";
import { cn } from "@/lib/utils";
import React from "react";
import type { Responsive, ResponsiveWrapperProps } from "./types";

function ResponsiveWrapper({
  base = {},
  responsive = {},
  className = "",
  children,
  ...props
}: ResponsiveWrapperProps) {
  const mergedResponsive = Object.keys({
    ...base,
    ...responsive,
  }).reduce<Responsive>((acc, key) => {
    const breakpoint = key as Breakpoint;
    const value = cn(base[breakpoint], responsive[breakpoint]);

    if (breakpoint === "sm") {
      acc.sm = value as `sm:${string}`;
    } else if (breakpoint === "md") {
      acc.md = value as `md:${string}`;
    } else if (breakpoint === "lg") {
      acc.lg = value as `lg:${string}`;
    }

    return acc;
  }, {});

  const classes = cn(Object.values(mergedResponsive), className);

  return (
    <Wrapper asChild={true} className={classes} {...props}>
      {children}
    </Wrapper>
  );
}

export default React.memo(ResponsiveWrapper);
